import React from 'react';
import ReactPlayer from 'react-player';

const Scenario4Video2 = () => {
    return (
        <div className='Scenario1VideoWrap Scenario1Video3'>
            <ReactPlayer url='https://youtu.be/T4i0OnCcMNU' controls={true} />
        </div>
    );
}

export default Scenario4Video2;